import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './style.scss';

export const PreviewImage = ({...props}) => {
  const {
    show,
    handleClose,
    imageUrl
  } = props;

  return (
    <Modal show={show} onHide={handleClose} dialogClassName='preview-dialog'>
      <Modal.Header closeButton />
      <Modal.Body>
        <img src={imageUrl} alt='s1-preview' className='s1-preview-image' />
      </Modal.Body>
    </Modal>
  );
};

PreviewImage.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  imageUrl: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/PreviewImage/index.js